import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import globalComponents from "./global-components";
import utils from "./utils";
import "./libs";
import maska from "maska";

import VueGtag from "vue-gtag";

// SASS Theme
import "./assets/sass/app.scss";

const app = createApp(App).use(store);

globalComponents(app);
utils(app);

app.use(maska);

const useGoogleAnaltyics = process.env.VUE_APP_USE_GA;
if (useGoogleAnaltyics > 0) {
  console.log("Use Google Analytics", process.env.VUE_APP_GA_ID);
  app.use(
    VueGtag,
    {
      config: { id: process.env.VUE_APP_GA_ID }
    },
    router
  );
}

const startApp = async () => {
  const root = document.getElementById("app");
  root.textContent = "Loading event settings…";
  try {
    await store.dispatch("main/setEventSettings");
    app.use(router);
    await router.isReady();
    app.mount("#app");
  } catch (error) {
    root.textContent = "Unable to load event settings. ";
    const retry = document.createElement("button");
    retry.textContent = "Retry";
    retry.className = "btn btn-primary";
    retry.addEventListener("click", startApp);
    root.appendChild(retry);
  }
};

startApp();
